export default function Oven() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="30" viewBox="0 0 36 30" fill="none">
            <rect x="1.62178" y="1.25898" width="32.7553" height="22.8668" rx="1.12306" stroke="#757575" strokeWidth="1.35" />
            <path d="M1.38074 20.0308H34.6184" stroke="#757575" strokeWidth="1.35" />
            <path d="M17.2174 22.0205L18.7811 22.0205" stroke="#757575" strokeWidth="1.35" strokeLinecap="round" />
            <path d="M14.5406 24.8008L14.135 27.1108" stroke="#757575" strokeWidth="1.35" strokeLinecap="square" />
            <path d="M21.4583 24.8008L21.8639 27.1108" stroke="#757575" strokeWidth="1.35" strokeLinecap="square" />
            <mask id="path-6-inside-1_512_18375" fill="white">
                <rect x="10.6565" y="27.1104" width="14.3764" height="2.3064" rx="0.899032" />
            </mask>
            <rect
                x="10.6565"
                y="27.1104"
                width="14.3764"
                height="2.3064"
                rx="0.899032"
                stroke="#757575"
                strokeWidth="2.025"
                mask="url(#path-6-inside-1_512_18375)"
            />
        </svg>
    );
}
